import { Component, Input } from '@angular/core';
import Required from '../../utility/decorators/required.decorator';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { LangService } from 'src/app/services/lang.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-arrow-circle',
  templateUrl: environment.components?.arrowCircle?.templateUrl,
  styleUrls: [environment.components?.arrowCircle?.styleUrls],
})
export class ArrowCircleComponent {
  @Input() @Required direction: 'up' | 'right' | 'down' | 'left' = 'up';
  @Input() @Required label = '';
  @Input() goTo: any[] | undefined;
  @Input() goToParams: any = {};
  @Input() disableClick = false;
  @Input() backRoute: any[] | undefined;

  constructor(
    private router: Router,
    private location: Location,
    public lang: LangService,
  ) {}

  get icon() {
    return 'arrow_' + this.direction;
  }

  async onClick() {
    if (this.disableClick) return;

    if (this.goTo) {
      const queryParams: any = this.goToParams;
      await this.router.navigate(this.goTo, { queryParams });
    } else if (this.backRoute) {
      await this.router.navigate(this.backRoute);
    } else {
      this.location.back();
    }
  }
}
